import React from "react";
import JobRoleSection from "./jobRole/JobRoleSection";
import BandSection from "./band/BandSection";

const RecruitmentConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-container'>
      <JobRoleSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <BandSection userDetails={userDetails} selectedClient={selectedClient} />
    </div>
  );
};

export default RecruitmentConfigSection;
